import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=f6729ee8&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=f6729ee8&prod&scoped=true&lang=scss&"
import style1 from "./Add.vue?vue&type=style&index=1&id=f6729ee8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6729ee8",
  null
  
)

export default component.exports